/*
Version 0.140

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2019.

!Changelog

2020
	17-02-2020
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_overlaymenu = {};

(function(){
	 
	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************

	this.onready = function() {
		
		/*
		Demo: Button
		*/
		$(document).on('click','.js-overlaymenu-open',function() {
			specific_overlaymenu.show();
		});
		
		/*
		Demo: Button
		*/
		$(document).on('click','.js-overlaymenu-close',function() {
			specific_overlaymenu.hide();
		});
		
	};
	
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	
	this.show = function(
	) {

		$('html,body').css({'overflow':'hidden'});
		
		$('.js-overlay-menu').show();
		
		$('.js-overlay-menu').stop().animate({
			top:0
		},500,'ease');

		setTimeout(function() {

			$('.js-overlay-menu').find('.menu a').map(function() {
				
				$(this).animate({
					'margin-top':'0'
				},500, 'ease');

			});

		},300);

	};

	this.hide = function() {

		$('html,body').css({'overflow':'auto'});

		$('.js-overlay-menu').find('.menu a').map(function() {
			
			$(this).animate({
				'margin-top':'10vw'
			},500, 'ease');

		});
		
		setTimeout(function() {

			$('.js-overlay-menu').stop().animate({
				top:'-100vh'
			},500,function() {
				$('.js-overlay-menu').hide();
			});

		},300);
		
	};
		
}).apply(specific_overlaymenu); 